// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2gDDu","dragIcon":"Choice_dragIcon__7xbod","left":"Choice_left__3u6Hn","input":"Choice_input__3NQLY"};